import { MaskedLines } from "./motion";

// Inner-page hero: navy canvas, blueprint grid, masked serif reveal.
export const PageHero = ({ eyebrow, title, description, children }) => (
  <section className="relative overflow-hidden bg-navy pt-40 pb-20 sm:pt-48 sm:pb-24">
    <div className="absolute inset-0 blueprint-grid" aria-hidden="true" />
    <div
      className="absolute -top-40 right-0 h-[520px] w-[520px] rounded-full bg-gold/10 blur-[140px]"
      aria-hidden="true"
    />
    <div className="container-x relative">
      <p className="eyebrow-on-dark">{eyebrow}</p>
      <MaskedLines
        lines={title}
        className="mt-6 max-w-4xl text-4xl font-medium leading-[1.08] tracking-tight text-white sm:text-5xl lg:text-6xl"
        delay={0.1}
      />
      {description && (
        <p className="mt-7 max-w-2xl text-base leading-relaxed text-white/60 sm:text-lg">
          {description}
        </p>
      )}
      {children}
    </div>
  </section>
);
